import { render, staticRenderFns } from "./applyTop.vue?vue&type=template&id=6b9906a4&scoped=true&"
import script from "./applyTop.vue?vue&type=script&lang=js&"
export * from "./applyTop.vue?vue&type=script&lang=js&"
import style0 from "./applyTop.vue?vue&type=style&index=0&id=6b9906a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9906a4",
  null
  
)

export default component.exports